import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LogService } from "@services/log.service";
import { Store } from '@ngxs/store';
import { CognosService } from '@services/cognos.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private _logger: LogService,
        private _store: Store,
        private _cognos: CognosService
      ) {
      }

    private reloginInProgress = false;

    getCookie(name) {
      const value = '; ' + document.cookie;
      const parts = value.split('; ' + name + '=');
      if (parts.length == 2) return parts.pop().split(';').shift()
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let modifiedReq = req.clone({
            headers: req.headers.delete('Cache-Control') // Remove the Cache-Control header
        });

        // Create a new headers object without the Cache-Control header
        const headers = modifiedReq.headers.keys().reduce((acc, key) => {
            if (key !== 'Cache-Control' && key !== 'X-Requested-With' && key !== 'ngsw-bypass') {
                acc = acc.set(key, modifiedReq.headers.get(key));
            }
            return acc;
        }, new HttpHeaders());

        modifiedReq = modifiedReq.clone({ headers }); // Set the new headers
        this._logger.info("load","AuthInterceptor", "req.headers: " + JSON.stringify(modifiedReq.headers));

        // Get XSRF Token either from cookie or localStorage, cookie has preference
        const xsrf = this.getCookie('XSRF-TOKEN') || localStorage.getItem('co_xsrf');
        if (xsrf) {
            localStorage.setItem('co_xsrf', xsrf);
            modifiedReq = modifiedReq.clone({
                setHeaders: {
                    'X-XSRF-TOKEN': xsrf
                }
            });
        }
        this._logger.info("load","AuthInterceptor", "req.url: " + JSON.stringify(modifiedReq.url));
        this._logger.info("load","AuthInterceptor", "req.headers: " + JSON.stringify(modifiedReq.headers));
        return next.handle(modifiedReq).pipe(
            catchError((err: unknown) => {
                if (
                    !this.reloginInProgress &&
                    err instanceof HttpErrorResponse &&
                    (err.status === 441 || err.status === 401 || err.status === 403)
                ) {
                    this.reloginInProgress = true;
                    this._logger.warn("load", "AuthInterceptor", `Auth error (${err.status}) detected. Triggering Cognos re-login flow.`);
                    try {
                        const config = (this._store.snapshot() as any)?.config;
                        if (config) {
                            void this._cognos.doLogoutAndLogin(config);
                        } else {
                            // If config isn't available yet, fall back to a full reload (bootstrap will re-init auth)
                            this._logger.warn("load", "AuthInterceptor", `Config not available yet. Falling back to a full reload.`);
                            location.reload();
                        }
                    } catch (e) {
                        // As a last resort, reload
                        this._logger.warn("load", "AuthInterceptor", `Error during re-login flow. Falling back to a full reload.`);
                        location.reload();
                    }
                }
                return throwError(() => err);
            })
        );
    }
}
